let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hc0i6")).then(() => parcelRequire('6uRAk'));